import React from "react";
import Marquee from "react-fast-marquee";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT } from "../data/site";

export const Reviews = () => {
  const { t } = useLang();

  return (
    <section id="reviews" className="bg-white py-24 sm:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.3em] text-teal">
              {t.reviews.kicker}
            </span>
            <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-purpleink-deep sm:text-5xl">
              {t.reviews.title}
            </h2>
          </div>
          <div className="flex flex-col items-start gap-4 sm:items-end">
            <a
              href={CONTACT.reviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-rating-link"
              className="flex items-center gap-4 rounded-2xl border border-marigold/40 bg-marigold/10 px-6 py-4 transition-colors hover:bg-marigold/20"
            >
              <span className="font-display text-5xl font-bold text-purpleink-deep">
                {t.reviews.rating}
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} className="h-4 w-4 fill-marigold text-marigold" />
                  ))}
                </div>
                <p className="mt-1 text-xs font-medium text-stone-600">{t.reviews.count}</p>
              </div>
            </a>
          </div>
        </div>

        <div className="-mx-5 sm:-mx-8" data-testid="reviews-slider">
          <Marquee speed={28} gradient={false} pauseOnHover autoFill>
            {t.reviews.items.map((r, i) => (
              <figure
                key={i}
                className="mx-3 flex h-full w-[340px] flex-col rounded-[1.5rem] border border-stone-200 bg-sand p-8 sm:w-[420px]"
                data-testid={`review-card-${i}`}
              >
                <Quote className="h-9 w-9 text-marigold" />
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-stone-700">
                  &ldquo;{r.text}&rdquo;
                </blockquote>
                <figcaption className="mt-6 flex items-center justify-between border-t border-stone-200 pt-5">
                  <span className="text-sm font-semibold text-purpleink-deep">{r.name}</span>
                  <div className="flex gap-0.5">
                    {[0, 1, 2, 3, 4].map((s) => (
                      <Star key={s} className="h-3.5 w-3.5 fill-marigold text-marigold" />
                    ))}
                  </div>
                </figcaption>
              </figure>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
